module.exports = require("promise/lib/rejection-tracking");